import { ValidationRule } from "../../error/validationRules";

export const signupFieldValidations: Record<string, ValidationRule[]> = {
  firstName: [ "isRequired" ],
  lastName: [ "isRequired" ],
  email: [ "isRequired", "isEmail" ],
  phoneNumber: [ "isRequired" ],
  marketingConsent: [ "isRequired", "isBoolean" ],
  "shippingAddress.postcode": [ "isRequired" ],
  "shippingAddress.address1": [ "isRequired" ],
  "shippingAddress.address2": [ ],
  "shippingAddress.city": [ "isRequired" ],
  "shippingAddress.province": [ "isRequired" ],
  "billingAddress.postcode": [ "isRequired" ],
  "billingAddress.address1": [ "isRequired" ],
  "billingAddress.address2": [ ],
  "billingAddress.city": [ "isRequired" ],
  "billingAddress.countryCode": [ "isRequired" ],
  deliveryDate: [ "isRequired" ],

  // Wildcard fallback for all cat fields
  "cat.*.name": [ "isRequired" ],
  "cat.*.gender": [ "isRequired" ],
  "cat.*.breed": [ "isRequired" ],
  "cat.*.lifeStage": [ "isRequired" ],
  "cat.*.age.years": [ "isRequired", "isNumber" ],
  "cat.*.age.months": [ "isRequired", "isNumber" ],
  "cat.*.age.weeks": [ "isRequired", "isNumber" ],
  "cat.*.isNeutered": [ "isRequired" ],
  "cat.*.body.type": [ "isRequired" ],
  "cat.*.body.activityLevel": [ "isRequired" ],
  "cat.*.weight.valueInKg": [ "isRequired", "isNumber", { type: "isBetween", min: 0, max: 20 } ],
  "cat.*.weight.valueInLb": [ "isRequired", "isNumber", { type: "isBetween", min: 0, max: 44 } ],
  "cat.*.weight.unit": [ "isRequired" ],
  "cat.*.diet.eatingHabits": [ "isRequired" ],
  "cat.*.diet.current.type": [ "isRequired", "isNotEmptyArray" ],
  "cat.*.diet.current.brand": [ "isRequired" ],
  "cat.*.diet.motivationsForSwitch": [ "isRequired" ],
  "cat.*.diet.healthConcernsToAddress": [ "isRequired", "isNotEmptyArray" ],
  "cat.*.medical.hasConditions": [ "isRequired" ],
  "cat.*.medical.conditions": [ "isRequired", "isNotEmptyArray" ],
  "cat.*.diet.foodAllergies.hasAllergies": [ "isRequired" ],
  "cat.*.diet.foodAllergies.allergens": [ "isRequired", "isNotEmptyArray" ],
};

export const signupFieldNameMap: Record<string, string> = {
  firstName: "First name",
  lastName: "Last name",
  email: "Email address",
  phoneNumber: "Phone number",
  marketingConsent: "Marketing consent",
  "shippingAddress.postcode": "Postcode",
  "shippingAddress.address1": "Address line 1",
  "shippingAddress.address2": "Address line 2",
  "shippingAddress.city": "City",
  "shippingAddress.province": "Province",
  "billingAddress.postcode": "Billing postcode",
  "billingAddress.address1": "Billing address line 1",
  "billingAddress.address2": "Billing address line 2",
  "billingAddress.city": "Billing city",
  "billingAddress.countryCode": "Country",
  deliveryDate: "Delivery date",
  "cat.*.name": "Cat name",
  "cat.*.gender": "Cat gender",
  "cat.*.breed": "Cat breed",
  "cat.*.lifeStage": "Life stage",
  "cat.*.age.years": "Age (years)",
  "cat.*.age.months": "Age (months)",
  "cat.*.age.weeks": "Age (weeks)",
  "cat.*.isNeutered": "Neutered status",
  "cat.*.body.type": "Body type",
  "cat.*.body.activityLevel": "Activity level",
  "cat.*.weight.value": "Weight",
  "cat.*.weight.unit": "Weight unit",
  "cat.*.diet.eatingHabits": "Eating habits",
  "cat.*.diet.current.type": "Current food type",
  "cat.*.diet.current.brand": "Current food brand",
  "cat.*.diet.motivationsForSwitch": "Reasons for switching",
  "cat.*.diet.healthConcernsToAddress": "Health concerns",
  "cat.*.medical.hasConditions": "Medical conditions",
  "cat.*.medical.conditions": "Medical conditions",
  "cat.*.diet.foodAllergies.hasAllergies": "Food allergies",
  "cat.*.diet.foodAllergies.allergens": "Food allergens",
};
